
import React from "react";
import moment from "moment-timezone";
import { Row, Col } from '@themesberg/react-bootstrap';

import { clientName } from "../helper/config";

export default (props) => {
  const currentYear = moment().get("year");

  return (
    <div>
      <footer className="footer section py-4">
        <Row>
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <p className="mb-0 text-center text-xl-left">
              Copyright © 2019-{`${currentYear} `}
              <span className="text-blue fw-normal">{clientName}</span>
            </p>
          </Col>
        </Row>
      </footer>
    </div>
  );
};
